import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

// const tabBarHeight = 48;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '380px',
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    borderLeft: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    position: 'relative'
  },
  content: {
    display: 'flex',
    width: '100%',
    height: '100%' //`calc(100% - ${tabBarHeight}px)`
  },
  tab: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: capitalDesignTokens.semanticColors.foreground.primary,
    borderBottom: 'none',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  tabActive: {
    color: capitalDesignTokens.semanticColors.foreground.action,
    borderBottom: `4px solid ${capitalDesignTokens.semanticColors.foreground.action}`
  }
});
